import { defineComponent as _defineComponent } from 'vue';
import { ref, onMounted } from 'vue';
import { FRAME_COLORS, ASSEMBLY_STEP_TYPES } from '../helpers/frameConstants';
import { renderFrameToSvg, trimSvg } from '../helpers/svgRenderer';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PrintFrameSvg',
    props: {
        data: { type: Object, required: true },
        isExploded: { type: Boolean, required: false },
        frameColor: { type: String, required: false },
        stepType: { type: String, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const svgRef = ref(null);
        onMounted(() => {
            if (svgRef.value && props.data) {
                renderFrameToSvg(svgRef.value, props.data, {
                    isExploded: props.isExploded ?? false,
                    frameColor: props.frameColor ?? FRAME_COLORS.SILVER,
                    viewport: { zoom: 1, panX: 0, panY: 0 },
                    stepType: props.stepType ?? ASSEMBLY_STEP_TYPES.ORGANIZE,
                });
                trimSvg(svgRef.value, 1);
            }
        });
        const __returned__ = { props, svgRef };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
